import { Box, Tab, Tabs } from '@mui/material'
import React, { ReactNode, useEffect, useState } from 'react'
import { ITabList } from '../types'

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: number
  align?: string
}

interface ITabProps {
  align?: 'center' | 'end' | 'start' | 'space-between'
  list: ITabList[]
  tabComponent: React.ReactElement[]
  changeTab?: number
  onChangeTab?: (item: any) => void
  filterSlot?: ReactNode
}

const CustomTabPanel = (props: TabPanelProps): JSX.Element => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{
        flexGrow: 1,
      }}
    >
      {value === index && <Box height="100%">{children}</Box>}
    </div>
  )
}

const a11yProps = (index: number): { id: string; 'aria-controls': string } => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

const ResactlyTab: React.FC<ITabProps> = ({
  align = 'center',
  list,
  tabComponent,
  changeTab,
  filterSlot,
  onChangeTab,
}) => {
  const [value, setValue] = useState(0)

  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    setValue(newValue)
    if (list.length && onChangeTab) {
      onChangeTab(list[newValue])
    }
  }

  useEffect(() => {
    if (changeTab) {
      setValue(changeTab)
    }
  }, [changeTab])

  return (
    <Box width="100%" height="100%" display="flex" flexDirection="column">
      <Box
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          display: 'flex',
          justifyContent: align ?? 'center',
          alignItems: 'center',
        }}
      >
        <Tabs
          value={value}
          variant="scrollable"
          scrollButtons={false}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          {list.map((tab, index) => (
            <Tab
              key={index}
              icon={tab.icon}
              iconPosition="start"
              label={tab.label}
              {...a11yProps(index)}
              sx={{
                paddingY: '0px',
                minHeight: '56px',
                textTransform: 'capitalize',
              }}
            />
          ))}
        </Tabs>
        {filterSlot && <Box>{filterSlot}</Box>}
      </Box>
      {tabComponent.map((tab, index) => (
        <CustomTabPanel key={index} value={value} index={index}>
          {tab}
        </CustomTabPanel>
      ))}
    </Box>
  )
}

export default ResactlyTab
